import { render, staticRenderFns } from "./PrsenterTheme.vue?vue&type=template&id=f0190cfc&scoped=true&"
import script from "./PrsenterTheme.vue?vue&type=script&lang=js&"
export * from "./PrsenterTheme.vue?vue&type=script&lang=js&"
import style0 from "./PrsenterTheme.vue?vue&type=style&index=0&id=f0190cfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0190cfc",
  null
  
)

export default component.exports